import { create } from "zustand";

export const useStore = create((set) => ({
  title: "NW SHOW",
  who: "",
  addWho: (value) => set({ who: value }),
  articles: [],
  addArticles: (value) => set({ articles: value }),
  articleNote: [],
  addArticleNote: (value) => {
    set({ articleNote: value });
  },
  note: "",
  addNote: (value) => set({ note: value }),
  increasePopulation: (value) =>
    set((state) => ({ bears: state.bears + value })),
  removeAllArticles: () => set({ articles: [] }),
}));
